// modules/categories/index.ts — Platik-IA
import { bus }          from '../../core/event-bus';
import { getModule }    from '../../core/registry';
import { getAllCategories, putCategories } from '../../services/idb';
import { writeCategories } from '../../services/google-sheets';
import type { CategoriesAPI } from './contracts';
import type { CategoryMap }   from '../../shared/types/global';

const DEFAULT_CATS: CategoryMap = {
  'Hogar':        ['Supermercado', 'Alimentos/Consumo diario', 'Servicios', 'Mantenimiento casa', 'Otros'],
  'Transporte':   ['Combustible', 'Automóvil', 'Transporte público', 'Otros'],
  'Vida':         ['Salud', 'Hijos', 'Entretenimiento/salidas', 'Streaming', 'Otros'],
  'Obligaciones': ['Impuestos', 'Donaciones', 'Otros'],
  'Ingresos':     ['Trabajo', 'Intereses/Inversiones', 'Otros'],
};

let _cats: CategoryMap = {};

export async function initCategories(): Promise<CategoriesAPI> {
  // Cargar desde IndexedDB
  const stored = await getAllCategories();
  _cats = stored.length > 0
    ? Object.fromEntries(stored.map(c => [c.name, c.subcategories]))
    : { ...DEFAULT_CATS };

  bus.emit('categories:ready');
  bus.emit('categories:updated', { categories: _cats });

  return {
    getAll: () => ({ ..._cats }),

    async save(categories) {
      _cats = { ...categories };

      // 1. Guardar en IndexedDB (inmediato)
      await putCategories(Object.entries(_cats).map(([name, subcategories]) => ({ name, subcategories })));
      bus.emit('categories:updated', { categories: _cats });

      // 2. Sync a Sheets (background)
      const auth = getModule<{ getUser: () => { sheetId: string | null } | null; getAccessToken: () => Promise<string | null> }>('auth');
      const user  = auth?.getUser();
      const token = await auth?.getAccessToken();

      if (user?.sheetId && token) {
        writeCategories(token, user.sheetId, _cats).catch(err => {
          console.warn('[categories] Error sincronizando a Sheets:', err);
        });
      }
    },

    dispose() {},
  };
}
